import { PROPERTY_STATUSES, type PropertyStatus } from '@erp/shared';

import type { ListingState } from '../../lib/properties-api.ts';
import { Badge } from '../ui/badge.tsx';

const STATUS_TONES = {
  draft: 'neutral',
  available: 'success',
  reserved: 'warning',
  sold: 'info',
  rented: 'info',
  withdrawn: 'neutral',
} as const satisfies Record<PropertyStatus, 'neutral' | 'success' | 'warning' | 'info'>;

export function StatusBadge({ status }: { status: PropertyStatus }) {
  return <Badge tone={STATUS_TONES[status]}>{PROPERTY_STATUSES[status]}</Badge>;
}

/** Where the listing agreement stands; nothing while it is far from ending. */
export function ListingBadge({ state }: { state: ListingState }) {
  if (state === 'expired') return <Badge tone="danger">Captación vencida</Badge>;
  if (state === 'expiring') return <Badge tone="warning">Captación por vencer</Badge>;
  return null;
}
